export default {
  namespaced: true,
  state: {
    summary: undefined,
    combined: {},
    objects: {},
  },
  mutations: {
    SET_OBJECTS(state, objectStats) {
      state.objects = objectStats;
    },
    SET_COMBINED(state, combinedStats) {
      state.combined = combinedStats;
    },
    SET_SUMMARY(state, summaryStats) {
      state.summary = _.cloneDeep(summaryStats.summary || summaryStats);
    },
  },
  actions: {
    CLEAR({ commit, getters }) {
      commit('SET_SUMMARY', {
        ...{
          summary: getters.defaults,
          combined: {},
          objects: {},
        },
      });
    },
    ADD_SUM({ getters, commit }, {
      timespan, energyType, direction, type, value,
    }) {
      const stats = getters.summary;

      stats[timespan][energyType][direction][type].sum += parseFloat(value || 0);

      commit('SET_SUMMARY', stats);
    },
  },
  getters: {
    objects: (state) => _.cloneDeep(state.objects),
    summary: (state, getters) => _.cloneDeep(state.summary || getters.summaryDefaults),
    combined: (state) => _.cloneDeep(state.combined),
    summaryDefaults: (state, getters, rootState) => {
      const summaryDefaults = {
        first: {},
        second: {},
      };

      Object.keys(rootState.centerUsageChart.supportedEnergyTypes).forEach((energyType) => {
        summaryDefaults.first[energyType] = {
          in: { normal: { sum: 0 }, blind: { sum: 0 } },
          out: { normal: { sum: 0 }, blind: { sum: 0 } },
        };
        summaryDefaults.second[energyType] = {
          in: { normal: { sum: 0 }, blind: { sum: 0 } },
          out: { normal: { sum: 0 }, blind: { sum: 0 } },
        };
      });

      return _.cloneDeep(summaryDefaults);
    },
  },
};
